/*
 *   File : add-admin.jsx
 *   Author : https://evoqins.com
 *   Description :
 *   Integrations :
 *   Version : 1.0.0
 */

import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CustomSelectMenu, Input } from "../../Components/FormElements";
import { PrimaryButton } from "../../Components/Cta";
import { SuccessModal } from "../../Components/Modals";
import { APIService } from "../../Service";
import { toast } from "react-toastify";

export default function AddAdmin() {
  const navigate = useNavigate();
  const { id } = useParams();

  // States
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [role, setRole] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [btnLoader, setBtnLoader] = useState(false);

  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [roleError, setRoleError] = useState("");

  // Load data for edit
  useEffect(() => {
    _getFilterData();
  }, []);

  useEffect(() => {
    const stored = JSON.parse(sessionStorage.getItem("editingSubAdmin"));
    if (stored) {
      setName(stored.username);
      setEmail(stored.email);
      setPhone(stored.mobile_number);
      setRole({ value: stored.role_id, label: stored.role });
    }
  }, [id]);

  // Validation functions
  const _validateName = () => {
    const trimmedName = name.trim();

    if (!trimmedName) {
      setNameError("Name is required");
      return false;
    }

    if (trimmedName.length > 25) {
      setNameError("Name should be lesser than 25 characters");
      return false;
    }

    setNameError("");
    return true;
  };

  const _validateEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email.trim()) {
      setEmailError("Email is required");
      return false;
    } else if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email address");
      return false;
    }

    setEmailError("");
    return true;
  };

  const _validatePhone = () => {
    const phoneRegex = /^[0-9]{10}$/;
    if (!phone.trim()) {
      setPhoneError("Phone number is required");
      return false;
    } else if (!phoneRegex.test(phone.trim())) {
      setPhoneError("Phone number must be exactly 10 digits");
      return false;
    }
    setPhoneError("");
    return true;
  };

  const _validateRole = () => {
    if (!role?.value) {
      setRoleError("Role is Required");
      return false;
    }
    setRoleError("");
    return true;
  };

  const _handleSave = () => {
    const isNameValid = _validateName();
    const isEmailValid = _validateEmail();
    const isPhoneValid = _validatePhone();
    const isRoleValid = _validateRole();

    if (isNameValid && isEmailValid && isPhoneValid && isRoleValid) {
      setBtnLoader(true);
      _upsert_subAdmin();
    }
  };

  //service to upsert subAdmin
  const _upsert_subAdmin = () => {
    const is_post = true;
    const payload = {
      type: id ? 2 : 1,
      admin_id: id ? id : null,
      username: name,
      email: email,
      mobile_number: phone,
      admin_type: role.value,
    };

    APIService(is_post, "sub-admin/upsert-admin", payload)
      .then((response) => {
        if (response.status_code === 200) {
          navigate("/manage-sub-admin");
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error(err.message);
      })
      .finally(() => {
        setBtnLoader(false);
      });
  };

  //service to get filter data
  const _getFilterData = () => {
    const is_post = false;
    APIService(is_post, "sub-admin/filter-data")
      .then((response) => {
        if (response.status_code === 200) {
          setFilterData(response.data);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  return (
    <div className="row px-3 e-pt-20px">
      <div className="col-lg-7">
        <div className=" e-bg-ghost-white-dark  e-border-radius-16 p-3 e-border-1px-pale-lavender w-100">
          <h5 className="e-font-16 e-primary-font-poppins e-font-weight-600 e-text-eerie-black line-height-24px pb-1">
            {id ? "Edit " : "Add "}details
          </h5>
          <div className="row">
            <div className=" col-lg-10 col-12">
              <div className="d-flex flex-column row-gap-3">
                <div className="row">
                  <Input
                    id="name"
                    type="text"
                    label="Name"
                    placeholder="Enter name"
                    require={true}
                    value={name}
                    error={nameError}
                    className="e-primary-font-poppins w-100"
                    onKeyPress={(e) => e.key === "Enter" && _validateName()}
                    handleChange={(e) => setName(e)}
                    autoFocus={!id}
                  />
                </div>

                <div className="row">
                  <Input
                    id="email"
                    type="text"
                    label="Email"
                    placeholder="Enter email"
                    require={true}
                    value={email}
                    error={emailError}
                    className="e-primary-font-poppins w-100"
                    onKeyPress={(e) => e.key === "Enter" && _validateEmail()}
                    handleChange={(e) => setEmail(e)}
                  />
                </div>

                <div className="row">
                  <Input
                    id="phone"
                    type="Number"
                    maxLength={10}
                    label="Phone Number"
                    placeholder="Enter phone number"
                    require={true}
                    value={phone}
                    error={phoneError}
                    className="e-primary-font-poppins w-100"
                    onKeyPress={(e) => e.key === "Enter" && _validatePhone()}
                    handleChange={(e) => setPhone(e)}
                  />
                </div>

                {/* Description Permissions */}
                <div className="row">
                  <label className="e-font-14 e-font-weight-500 text-capitalize e-primary-font-poppins mb-2">
                    Role Name <span className="text-danger">*</span>
                  </label>
                  <CustomSelectMenu
                    options={filterData}
                    placeholder="Select Role"
                    isMulti={false}
                    value={role}
                    onChange={(selected) => setRole(selected)}
                    type={2}
                  />
                  {roleError && (
                    <span className="text-danger e-primary-font-poppins e-font-12 mt-1">
                      {roleError}
                    </span>
                  )}
                </div>

                {/* Button Group */}
                <div className="row">
                  <div className="col-12">
                    <div className="row">
                      <div className="col-6">
                        <PrimaryButton
                          ClassName="e-border-radius-pill e-border-1px-blue e-font-weight-500 e-font-16 w-100 bg-transparent e-text-blue-violet e-primary-font-poppins"
                          name="Cancel"
                          onPress={() => navigate("/manage-sub-admin")}
                        />
                      </div>
                      <div className="col-6">
                        <PrimaryButton
                          loading={btnLoader}
                          ClassName="e-border-radius-pill e-font-weight-500 e-font-16 w-100 e-bg-blue-violet text-white e-primary-font-poppins"
                          name={
                            id ? "Update & Send Invitation" : "Send Invitation"
                          }
                          onPress={_handleSave}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <SuccessModal
          title={"Delete Banner?"}
          close={() => setShowModal(false)}
          onClick={() => setShowModal(false)}
        />
      )}
    </div>
  );
}
